export default __webpack_public_path__ + "static/media/NoScreenShot.292a2992.svg";